"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Driver_1 = require("../models/Driver");
var mockDriver = __assign(__assign({}, Driver_1.makeEmptyDriver()), { firstName: 'mock-first-name', lastName: 'mock-last-name', gender: 'M', birthday: '12/12/2020', transitZone: '0', transitTime: '0', foulsQty: '0', nationality: '0', email: 'mockEmail@mail.com', phoneNumber: '123456' });
exports.default = mockDriver;
//# sourceMappingURL=mockDriver.js.map